module.exports = __webpack_public_path__ + "assets/img/top-bg1.c50bc9c0.png";